import i18n from "../../i18n";

const CarouselItem = ({ active, image, title, description, link }) => {
  return (
    <div className={active ? "carousel-item active" : "carousel-item"}>
      <img src={image} style={{ opacity: "50%" }} alt={title} fetchpriority={active ? "high" : "low"} loading={active ? "eager" : "lazy"}></img>

      <div className="container">
        <div className="carousel-caption text-start">
          <h1>{title}</h1>
          <p>{description}</p>
          <p>
            <a className="btn btn-lg btn-primary" href={link}>
              {i18n.t("landingPage_carousel_button")}
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CarouselItem;
